export default "__VITE_ASSET__CiC_ATmo__"